<template>
  <v-container>
    <v-dialog v-model="showDialog" max-width="480px" persistent>
      <v-card>
        <v-card-title class="headline">Kelengkapan Data</v-card-title>
        <v-card-text>
          {{ cardText }}
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary" @click="redirectToPage()">Mengerti</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
import _ from 'lodash'
import SKPService from "@/services/SKPService"
import store from "@/store";

export default {
  props: {
  },
  data(){
    return {
      showDialog: false,
      cardText: "",
      validationData: []
    }
  },
  created(){
    let current = store.state.user.current;
    if(current.year >= 2024){
      this.validateSkp()
    }

  },
  methods:{
    async validateSkp() {
      try {
        await SKPService.validatorSKP()
      } catch (err) {
        const data = err.response?.data || {};

        this.validationData = data.data?.details || [];
        this.cardText = data.message || "Server sedang sibuk, silahkan coba beberapa saat lagi";

        this.showDialog = true
      }
    },
    redirectToPage(){
      for (const val of this.validationData) {
        if (!val.is_valid) {
          const route = val.type === "SKP_TAHUNAN" ? "/skp/tahunan" : "/skp/triwulan";
          this.$router.push(route);
          break;
        }
      }
    }
  }
}
</script>
